import type { SlotClassNames } from '@fluentui/react-components';
import { makeStyles, mergeClasses } from '@fluentui/react-components';
import { tokens, typographyStyles } from '@fluentui-copilot/tokens';
import type { AiGeneratedDisclaimerSlots, AiGeneratedDisclaimerState } from './AiGeneratedDisclaimer.types';

export const aiGeneratedDisclaimerClassNames: SlotClassNames<AiGeneratedDisclaimerSlots> = {
  root: 'fai-AiGeneratedDisclaimer',
};

const useStyles = makeStyles({
  root: {
    ...typographyStyles.caption2Strong,
    borderRadius: tokens.borderRadiusMedium,
    padding:
      // 14px tall text + 1px padding on top and bottom = 16px total height
      `calc(${tokens.spacingVerticalXXS} / 2) ` + // 1px
      `${tokens.spacingHorizontalXS} ` +
      `calc(${tokens.spacingVerticalXXS} / 2) ` + // 1px
      tokens.spacingHorizontalXS,
    display: 'inline-block',
    color: tokens.colorNeutralForeground3,
    backgroundColor: tokens.colorNeutralBackground5,
    fontWeight: tokens.fontWeightRegular,
  },
  canvas: {
    padding:
      // 14px tall text + 3px padding on top and bottom = 20px total height
      `calc(${tokens.spacingVerticalSNudge} / 2) ` + // 3px
      `${tokens.spacingHorizontalSNudge} ` + // 6px
      `calc(${tokens.spacingVerticalSNudge} / 2)` + // 3px
      tokens.spacingHorizontalSNudge, // 6px
  },
});

const useNextStyles = makeStyles({
  root: {
    borderRadius: tokens.borderRadiusXLarge,
  },
});

export const useAiGeneratedDisclaimerStyles_unstable = (
  state: AiGeneratedDisclaimerState,
): AiGeneratedDisclaimerState => {
  'use no memo';
  const { mode, designVersion } = state;

  const styles = useStyles();
  const nextStyles = useNextStyles();

  state.root.className = mergeClasses(
    aiGeneratedDisclaimerClassNames.root,
    styles.root,
    mode === 'canvas' && styles.canvas,
    designVersion === 'next' && nextStyles.root,
    state.root.className,
  );

  return state;
};
